module.exports = __webpack_public_path__ + "img/discord-w.0171fee9.svg";